import styled from "styled-components";
import { Container } from "../layout/Container";

const Hero = styled.section`
  background: hsl(${({ theme }) => theme.colors.navDark});
  padding: 2.5rem 0;
`;

const HeroInner = styled(Container)`
  text-align: center;
`;

const H1 = styled.h1`
  margin: 0 0 0.5rem;
  font-size: ${({ theme }) => theme.font.heroTitle};
  font-weight: 800;
  color: hsl(${({ theme }) => theme.colors.navDarkForeground});
`;

const Lead = styled.p`
  margin: 0;
  color: hsl(${({ theme }) => theme.colors.navDarkForeground} / 0.65);
  font-size: clamp(0.9375rem, 0.88rem + 0.25vw, 1.125rem);
`;

const Body = styled(Container)`
  padding: 2rem 1rem 3rem;
  max-width: ${({ theme }) => theme.layout.proseMax};
`;

const Prose = styled.div`
  font-size: clamp(0.9375rem, 0.88rem + 0.2vw, 1.0625rem);
  line-height: 1.7;
  color: hsl(${({ theme }) => theme.colors.foreground});
  p {
    margin: 0 0 1rem;
  }
  ul {
    margin: 0 0 1rem 1.25rem;
    padding: 0;
  }
`;

export default function PageWithHero({ title, subtitle, children }) {
  return (
    <>
      <Hero>
        <HeroInner>
          <H1>{title}</H1>
          {subtitle && <Lead>{subtitle}</Lead>}
        </HeroInner>
      </Hero>
      <Body>
        <Prose>{children}</Prose>
      </Body>
    </>
  );
}
